<template>
    <nav class="navbar-left">
        <ul class="navbar-left__list">
            <li
                v-for="(item,index) in buttons"
                :key="index"
                :id="item.id"
                class="navbar-left__item"
            >
                <a
                    class="navbar-left__link"
                    :title="item.title"
                    @click="Change_Style_Button(item.marker)"
                >
                    <img
                        :id="item.idImg"
                        class="navbar-left__image"
                        :src="item.src"
                    >
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>

    import {mapMutations, mapState} from 'vuex';
    import buttonsList from './buttons.js'

    export default {

        name: 'LeftMenu',

        data () {
            return {
                buttons: buttonsList
            }
        },

        computed:{
            ...mapState('markers',['markersHidro','markersAcele','markersPhrea','markersAirq','allMarkers']),

            markers(){
                let array = [];
                array.push(this.markersHidro);
                array.push(this.markersAcele);
                array.push(this.markersPhrea);
                array.push(this.markersAirq);
                array.push(this.allMarkers);
                return array
            }
        },

        methods: {
            async Change_Style_Button(marker) {

                await this.Modify_Marker_Group(marker);

                let Orange = 'rgb(233, 103,41)';
                let Grey = 'rgb(94, 107, 93)';

                for(var i in this.buttons) {
                    let changeImage = document.getElementById(this.buttons[i].idImg);
                    let changeBackground = document.getElementById(this.buttons[i].id);
                    if(this.markers[i]) {
                        changeImage.src = this.buttons[i].src;
                        changeBackground.style.backgroundColor = Orange;
                    } else {
                        changeImage.src = this.buttons[i].srcChange;
                        changeBackground.style.backgroundColor = Grey;
                    }
                }
            },

            ...mapMutations('markers',['Modify_Marker_Group'])
        }
    };
</script>

<style scoped lang="scss">
    .navbar-left {
        align-items: center;
        display: flex;
        height: 100%;
        left: 2px;
        padding: 0;
        position: fixed;
        text-align: center;
        top: 0;
        z-index: 1;

        &__list {
            list-style: none;
            margin-bottom: 2rem;
            padding: 0;
        }

        &__item {
            background-color: $main-color;
            border-radius: .5em;
            box-shadow: .2em .2em .3em $dark-color;
            height: 3.5em;
            margin-top: .2rem;
            opacity: 0.75;
            padding: .4rem 0;
            width: 4.5em;
        }

        &__link {
            background-color: transparent;
        }

        &__image {
            &:hover {
                -webkit-transform: rotate(-45deg);
                transform: rotate(45deg);
                transition:transform 0.5s;
            }

            -webkit-transition: -webkit-transform 0.5s;
            height: 100%;
            transition:transform 0.5s;
            width: auto;
        }
    }

    @media (max-height: 560px){
        .navbar-left {
            left: 6em;

            &__item {
                height: 2.8em;
                width: 3.3em;
            }
        }
    }

    @media (max-width: 600px) {
        .navbar-left {
            &__item {
                height: 2.8em;
                width: 3.3em;
            }
        }
    }

    @media (min-width: 1500px) and (min-height: 900px){
        .navbar-left {
            &__item {
                height: 4em;
                width: 5em;
            }
        }
    }
</style>
